import React, { useCallback } from 'react'

import { useDeliveryForecastProcessStep } from '../../../data/settings'
import { DeliveryForecastProcessStep } from '../../../data/settings/models'
import { useSearchParam } from '../../../hooks'
import { DeliveryForecastsTable } from './DeliveryForecastsTable'
import { DespatchAdvicesTable } from './DespatchAdvicesTable'
import { Title } from './Title'

export const DeliveryForecasts: React.FC = () => {
  const { data: processStep } = useDeliveryForecastProcessStep()
  const [searchParam, setSearchParam] = useSearchParam('search')

  const isVisibleDeliveryForecasts = useCallback((): boolean => {
    return processStep !== undefined
      ? [
          DeliveryForecastProcessStep.CONFIRMATION,
          DeliveryForecastProcessStep.DESPATCHADVICE,
          DeliveryForecastProcessStep.DESPATCHADVICE_WITH_CONFIRMATION,
        ].includes(processStep)
      : true
  }, [processStep])

  const isVisibleDespatchAdvices = useCallback((): boolean => {
    return processStep !== undefined
      ? [
          DeliveryForecastProcessStep.DESPATCHADVICE,
          DeliveryForecastProcessStep.DESPATCHADVICE_WITH_CONFIRMATION,
        ].includes(processStep)
      : false
  }, [processStep])

  return (
    <>
      <Title
        globalFilterValue={searchParam}
        setGlobalFilterValue={setSearchParam}
      />

      <DeliveryForecastsTable
        globalFilterValue={searchParam}
        setGlobalFilterValue={setSearchParam}
        isVisible={isVisibleDeliveryForecasts()}
      />

      <DespatchAdvicesTable
        globalFilterValue={searchParam}
        setGlobalFilterValue={setSearchParam}
        isVisible={isVisibleDespatchAdvices()}
      />
    </>
  )
}
